import { render } from "./BannerInf.vue?vue&type=template&id=e2ef95b8&class=mainBanerInf"
const script = {}

import "./BannerInf.vue?vue&type=style&index=0&id=e2ef95b8&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\andremudancasemgeral\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__